import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import { Box, IconButton, Paper, Tooltip } from "@mui/material";
import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import CoreButton from "../../../app/core/components/CoreButton/CoreButton";
import CoreButtonIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import { getUploadURL, uploadFile } from "./CaricaDocumentiSlice";
// import CoreSelectObjArr from "../../../app/core/components/CoreSelect/CoreSelectObjArr";
import {
  useCreatePracticeDocumentMutation,
  useGetPracticeManagementQuery,
} from "../../api/user/gestisciPraticheApi";
import { useCreateDocumentMutation } from "../../api/user/gestisciDocumentiApi";
import { t } from "i18next";
import TextSnippetRoundedIcon from "@mui/icons-material/TextSnippetRounded";
import { useLocation, useNavigate } from "react-router-dom";
import CoreTextArea from "../../../app/core/components/CoreTextArea/CoreTextArea";
import LockScreen from "../../../app/core/components/CoreLockScreen/LockScreen";
import CoreBack from "../../../app/core/components/CoreBack/CoreBack";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

const CaricaDocumentiPage = () => {
  const location = useLocation();
  const appConfig = useSelector((state) => state.app.appConfig);
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileIndexForEditing, setFileIndexForEditing] = useState(-1);
  const [progress, setProgress] = useState(0);
  const [selectedPractice, setSelectedPractice] = useState(null); // location?.state || null (passaggio ID practice)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: practicesData } = useGetPracticeManagementQuery({
    page: {
      currentPage: 1,
      startRow: 0,
      endRow: 1000,
    },
    filter: {
      status: "",
      startDate: "",
      endDate: "",
    },
    orderDirection: "desc",
    valueToOrderBy: "createdAt",
  });
  const [createPracticeDocument] = useCreatePracticeDocumentMutation();
  const [createDocument] = useCreateDocumentMutation();
  const handleFileDrop = (acceptedFiles) => {
    const validFiles = acceptedFiles.filter(
      (file) =>
        file.type === "application/pdf" || file.type.startsWith("image/")
    );

    if (validFiles.length > 0) {
      setSelectedFiles((prevFiles) => [...prevFiles, ...validFiles]);
    } else {
      toast.error(t("InvalidFile"));
    }
  };

  const rimuoviFile = (index) => {
    const nuoviFiles = [...selectedFiles];
    nuoviFiles.splice(index, 1);
    setSelectedFiles(nuoviFiles);
  };

  const createDocumentData = (files) => {
    const firstFile = files[0];
    const fileExtension = firstFile.name.split(".").pop();
    const documentData = {
      filesCount: files.length,
      name: firstFile.name,
      extensions: [fileExtension],
      documentScope: "PERSONAL",
      notes: firstFile.notes,
    };
    return documentData;
  };

  const updateProgress = (percentage) => {
    setProgress(percentage);
  };

  const confermaCaricamento = async () => {
    if (selectedFiles.length > 0) {
      setLoading(true);
      const totalFiles = selectedFiles.length;
      let uploadedFilesCount = 0;
      let uploadUrlResponse;
      try {
        for (const file of selectedFiles) {
          uploadUrlResponse = await dispatch(getUploadURL());
          const uploadUrl = uploadUrlResponse.payload;
          await dispatch(
            uploadFile({
              url: uploadUrl,
              file: new Blob([file]),
              type: file.type,
            })
          );
          const documentData = createDocumentData([file]);
          const practiceDocumentData = {
            ...documentData,
            s3FilePath: uploadUrl.split("?")[0],
            scope: "PERSONAL",
            practiceId: selectedPractice,
            fileName: file.name,
          };
          documentData.s3FilesPath = [uploadUrl.split("?")[0]];
          const resp = selectedPractice
            ? await createPracticeDocument({
                cleanedDocumentData: practiceDocumentData,
                praticaId: selectedPractice,
              })
            : await createDocument(documentData);
          if (!resp.error) uploadedFilesCount++;
          const currentProgress = Math.round(
            (uploadedFilesCount / totalFiles) * 100
          );
          updateProgress(currentProgress);
        }
        if (uploadedFilesCount === totalFiles) toast.success(t("DocsLoaded"));
        else
          toast.error(
            `${totalFiles - uploadedFilesCount} ${t("DocsNotLoaded")}`
          );
        setLoading(false);
      } catch (error) {
        if (
          error.response &&
          error.response.status === 200 &&
          error.response.data &&
          error.response.data.exception
        ) {
          toast.error(t("DocsNotLoaded"));
        } else {
          toast.error(t("DocsNotLoaded"));
        }
        setLoading(false);
      } finally {
        setSelectedFiles([]);
        updateProgress(0);
      }
    }
  };

  const handleFileIndexForEditingChange = (i) => {
    if (i === fileIndexForEditing) {
      setFileIndexForEditing(-1);
      return;
    }
    setFileIndexForEditing(i);
  };

  const handleEditFile = (notes) => {
    const nuoviFiles = [...selectedFiles];
    nuoviFiles[fileIndexForEditing].notes = notes;
    setSelectedFiles(nuoviFiles);
  };

  return (
    <div className="w-11/12">
      <LockScreen
        text={
          <div className="w-full text-center mt-4 flex flex-col items-center gap-4">
            <p> {t("UploadingDocExt")}</p>
            <div className="w-96">
              <div>{progress + "%"}</div>

              <DotLottieReact
                src="https://lottie.host/640307c9-8f67-4933-a20b-5ccca2473aac/D56P0e8La1.json"
                loop
                autoplay
              />
            </div>
          </div>
        }
        openTrigger={loading}
        zIndex={10000}
      />
      <div className="flex  items-center w-full ">
        <CoreBack />
        <h2>{t("UploadDoc")}</h2>
      </div>
      <Box component={Paper} elevation={4} style={{ height: "75vh" }}>
        <div className="flex p-8 space-x-8">
          {/* {appConfig?.modules?.practice?.general && ( // selezione
            <div className="w-3/12">
              <div className="flex flex-col gap-6">
                <CoreSelectObjArr
                  disabled
                  label={`${t("SelectPractice")} (${t("optional")})`}
                  value={selectedPractice}
                  onChange={(e) => setSelectedPractice(e.target.value)}
                  items={[
                    {
                      value: null,
                      label: <p className="italic m-0">{t("NoOne")}</p>,
                    },
                  ].concat(
                    practicesData?.Data?.items.map((p) => ({
                      value: p.id,
                      label: p.name,
                    })) || []
                  )}
                />
              </div>
            </div>
          )} */}
          <div className="w-5/12">
            <div>
              <Dropzone onDrop={handleFileDrop} accept={["image/*", ".pdf"]}>
                {({ getRootProps, getInputProps }) => (
                  <div
                    className="flex justify-center items-center cursor-pointer"
                    {...getRootProps()}
                    style={{
                      border: "2px dashed #ccc",
                      minHeight: "65vh",
                    }}
                  >
                    <input {...getInputProps()} />
                    <div className="flex flex-col items-center justify-center">
                      <p className="text-center text-gray">{t("DropFile")}</p>
                      <CoreButtonIcon
                        icon={
                          <UploadFileRoundedIcon
                            className="text-gray"
                            sx={{ fontSize: 70 }}
                          />
                        }
                      />
                      <CoreButtonIcon
                        icon={<SearchRoundedIcon className="text-gray" />}
                        testo={t("Search")}
                        className="text-gray"
                      />
                    </div>
                  </div>
                )}
              </Dropzone>
            </div>
          </div>
          <div className="w-6/12">
            {selectedFiles.length > 0 ? (
              <div
                style={{ height: "69vh" }}
                className="flex flex-col items-center"
              >
                {!loading && (
                  <>
                    <div className="overflow-y-scroll w-full p-2 border-solid border border-stone-100 rounded-md">
                      {selectedFiles.map((file, index) => (
                        <>
                          <div
                            key={index}
                            className="w-full flex items-center flex-row justify-between "
                          >
                            <p>{file.name}</p>

                            <div className="flex gap-1">
                              <Tooltip
                                title={
                                  selectedFiles[index]?.notes?.trim()
                                    ? t("Edit") + " " + t("Notes").toLowerCase()
                                    : t("Add") + " " + t("Notes").toLowerCase()
                                }
                              >
                                <IconButton>
                                  <TextSnippetRoundedIcon
                                    onClick={() =>
                                      handleFileIndexForEditingChange(index)
                                    }
                                    className={
                                      selectedFiles[index]?.notes?.trim() &&
                                      "text-green-700"
                                    }
                                  />
                                </IconButton>
                              </Tooltip>
                              <IconButton>
                                <DeleteRoundedIcon
                                  onClick={() => rimuoviFile(index)}
                                  className="text-rose-700"
                                />
                              </IconButton>
                            </div>
                          </div>
                          {fileIndexForEditing === index && (
                            <CoreTextArea
                              className="w-3/4 mb-8"
                              rows={2}
                              name="notes"
                              label={t("Notes")}
                              onChange={(e) => handleEditFile(e.target.value)}
                              value={selectedFiles[index].notes}
                            />
                          )}
                        </>
                      ))}
                    </div>
                    <div className="mt-4">
                      <CoreButton
                        className={"btn-round"}
                        onClick={confermaCaricamento}
                        testo={t("Upload")}
                      />
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="flex h-full items-center justify-center text-gray">
                {t("NoDocs")}
              </div>
            )}
          </div>
        </div>
      </Box>
    </div>
  );
};

export default CaricaDocumentiPage;
